/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */


import {EditableContextNodeListItem} from "./EditableContextNodeListItem";
import {ContextNodeChildrenList} from "./ContextNodeChildrenList";
import {useFilterByProjectStatus} from "../../../Hooks/useFilterByProjectStatus";

// Project statuses considered "inactive" — shared by the children list and
// the project map so both hide/reveal the same set of projects.
export const INACTIVE_PROJECT_STATUS_CODES = ['abandoned', 'inactive'];

export const ProjectContextNodeChildrenList = (props) => {
    const filterInactiveProjects = useFilterByProjectStatus(INACTIVE_PROJECT_STATUS_CODES);

    return <ContextNodeChildrenList
        title={"Projects"}
        listFilter={filterInactiveProjects}
        itemComponent={EditableContextNodeListItem}
        revealButtonLabel={ (count) => `${count} Inactive Project${count !== 1 ? 's' : ''}`}
        filterSectionLabel={ (count) => `${count} Inactive Project${count !== 1 ? 's' : ''}`}
        {...props}
    />;
}
